/**
 * Spacer Size
 */
export var SpacerSize;
(function (SpacerSize) {
    SpacerSize[SpacerSize["ZERO"] = 0] = "ZERO";
    SpacerSize[SpacerSize["ONE"] = 4] = "ONE";
    SpacerSize[SpacerSize["TWO"] = 8] = "TWO";
    SpacerSize[SpacerSize["THREE"] = 12] = "THREE";
    SpacerSize[SpacerSize["FOUR"] = 16] = "FOUR";
    SpacerSize[SpacerSize["FIVE"] = 24] = "FIVE";
    SpacerSize[SpacerSize["SIX"] = 32] = "SIX";
    SpacerSize[SpacerSize["SEVEN"] = 40] = "SEVEN";
    SpacerSize[SpacerSize["EIGHT"] = 48] = "EIGHT";
    SpacerSize[SpacerSize["NINE"] = 56] = "NINE";
    SpacerSize[SpacerSize["TEN"] = 64] = "TEN";
})(SpacerSize || (SpacerSize = {}));
export var SpacerSizeValues = "".concat(SpacerSize);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3BhY2VyRW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvc3BhY2VyL1NwYWNlckVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxVQVlYO0FBWkQsV0FBWSxVQUFVO0lBQ3BCLDJDQUFRLENBQUE7SUFDUix5Q0FBTyxDQUFBO0lBQ1AseUNBQU8sQ0FBQTtJQUNQLDhDQUFVLENBQUE7SUFDViw0Q0FBUyxDQUFBO0lBQ1QsNENBQVMsQ0FBQTtJQUNULDBDQUFRLENBQUE7SUFDUiw4Q0FBVSxDQUFBO0lBQ1YsOENBQVUsQ0FBQTtJQUNWLDRDQUFTLENBQUE7SUFDVCwwQ0FBUSxDQUFBO0FBQ1YsQ0FBQyxFQVpXLFVBQVUsS0FBVixVQUFVLFFBWXJCO0FBRUQsTUFBTSxDQUFDLElBQU0sZ0JBQWdCLEdBQUcsVUFBRyxVQUFVLENBQUUsQ0FBQSJ9